import { css } from 'styled-components';

export default (...breakpoints) => (...styles) => css`
  @media only screen and (min-width: ${breakpoints[0] + 1}px) and (max-width: ${breakpoints[1]}px) {
    ${css(...styles)}
  }
`;
